<template>
  <div class="how-section__list-wrapper">
    <ul class="how-section__list">
      <li
        v-for="item in $options.consts.SECTION_ITEMS"
        :key="item.icon"
        class="how-section__item"
      >
        <a-icon
          :icon="item.icon"
          width="auto"
          height="auto"
          :no-hover="true"
          :original="true"
          class="how-section__item-logo"
        />

        <h3
          class="how-section__item-title"
          :style="`color: ${item.titleColor};`"
        >
          {{ item.title }}
        </h3>
        <p
          class="how-section__item-description text-caption"
          v-html="item.description"
        />
      </li>
    </ul>

    <div class="how-section__contact text-caption">
      Explore our extensive range of solutions.

      <a-visibility show :from="$breakpoint.desktopMd">
        <a-link
          :to="$options.consts.FORM_HASH"
          :scroll-to-delay="$options.consts.FORM_SCROLL_TO_DELAY"
          class="how-section__contact-link"
        >
          Contact our sales team
        </a-link>
      </a-visibility>

      <a-visibility show :to="$breakpoint.desktopSm">
        <a-button
          :href="$options.consts.FORM_HASH"
          :scroll-to-delay="$options.consts.FORM_SCROLL_TO_DELAY"
          :open-in-new-tab="false"
          class="how-section__contact-btn"
        >
          Contact our sales team
        </a-button>
      </a-visibility>
    </div>
  </div>
</template>

<script>
import AIcon, { ICON } from 'shared/AIcon/index.vue'
import { ELEMENT_ID } from 'enums/element-id'

export default {
  name: 'HomepageHowSectionList',
  components: { AIcon },
  consts: {
    FORM_HASH: `#${ELEMENT_ID.LEAD_FORM}`,
    FORM_SCROLL_TO_DELAY: 1000,
    SECTION_ITEMS: [
      {
        icon: ICON.REVIEW_AND_LISTING,
        title: 'Review and listing',
        titleColor: '#009acf',
        description:
          "Control your brand's image:\n let reviews define your online presence."
      },
      {
        icon: ICON.CONTENT_360,
        title: 'Content 360',
        titleColor: '#c100cf',
        description: "Don't just join the conversation\n lead with your brand!"
      },
      {
        icon: ICON.INTERVIEWS,
        title: 'Interviews',
        titleColor: '#00cfac',
        description:
          'Position your brand at the core of topics aligned with your business and values.'
      },
      {
        icon: ICON.TARGETED_EMAIL_OUTREACH,
        title: 'Targeted email outreach',
        titleColor: '#cf7600',
        description: 'Connects your brand directly with your audience.'
      },
      {
        icon: ICON.AD_SPOTLIGHT,
        title: 'Ad spotlight',
        titleColor: '#00a22c',
        description:
          'Increases brand visibility and web traffic with strategically placed banner ads.'
      },
      {
        icon: ICON.BIG_DATA_REPORTS,
        title: 'Big data reports',
        titleColor: '#0044d4',
        description:
          'Gain in-depth analysis and insights with our intelligence reports.'
      }
    ]
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/scss/local/mixins/grid';

$icon-size: (
  $above-desktop-xl: (
    'width': 111px,
    'height': 88px
  ),
  $desktop-sm: (
    'width': 74px,
    'height': 60px
  )
);

.how-section__list-wrapper {
  $margin-top: (
    $above-desktop-xl: 45px,
    $desktop-sm: 30px,
    $mobile: 20px
  );

  @include setStyleByBreakpoint('margin-top', $margin-top);

  .how-section__list {
    $grid-setup: (
      $columnSetup: (
        $above-desktop-xl: 1fr 1fr 1fr,
        $desktop-sm: 1fr 1fr
      ),
      $columnGapSetup: (
        $above-desktop-xl: 50px,
        $desktop-sm: 46px,
        $mobile: 19px
      )
    );

    @include gridBuilder($grid-setup);
  }

  .how-section__item {
    display: flex;
    flex-direction: column;

    $margin-bottom: (
      $above-desktop-xl: 45px,
      $desktop-sm: 25px
    );

    @include setStyleByBreakpoint('margin-bottom', $margin-bottom);
  }

  .how-section__item-logo {
    $width: (
      $above-desktop-xl: map-deep-get($icon-size, $above-desktop-xl, 'width'),
      $desktop-sm: map-deep-get($icon-size, $desktop-sm, 'width')
    );

    $height: (
      $above-desktop-xl: map-deep-get($icon-size, $above-desktop-xl, 'height'),
      $desktop-sm: map-deep-get($icon-size, $desktop-sm, 'height')
    );

    @include setStyleByBreakpoint('width', $width);
    @include setStyleByBreakpoint('height', $height);
  }

  .how-section__item-title {
    $margin-top: (
      $above-desktop-xl: 25px,
      $desktop-sm: 10px
    );

    $margin-bottom: (
      $above-desktop-xl: 10px,
      $desktop-sm: 0
    );

    @include setStyleByBreakpoint('margin-top', $margin-top);
    @include setStyleByBreakpoint('margin-bottom', $margin-bottom);
  }

  .how-section__item-description {
    margin-top: 7px;
    white-space: pre-line;

    $min-height: (
      $above-desktop-xl: 92px,
      $desktop-sm: 53px,
      $mobile: auto
    );

    @include setStyleByBreakpoint('min-height', $min-height);
  }

  .how-section__contact {
    display: flex;
    justify-content: center;
    align-items: center;

    $margin-top: (
      $above-desktop-xl: 25px,
      $desktop-sm: 11px,
      $mobile: 3px
    );

    @include setStyleByBreakpoint('margin-top', $margin-top);

    @include mobile {
      flex-direction: column;
    }

    .how-section__contact-link {
      margin-left: 4px;
      font-weight: 500;
    }

    .how-section__contact-btn {
      border-radius: 4px;
      margin-left: 12px;
      width: 245px;
      height: 45px;
      font-size: 15px;

      @include mobile {
        margin-top: 6px;
      }
    }
  }
}
</style>
